<template>
<div class="page flex componentPage">
    <div v-if='look'>
        <el-col :span='4' style='margin-top:-20px;margin-bottom:5px;'><el-button type="primary" @click="add" size="small">新增催收记录</el-button></el-col>
        <el-table :data='dataList' border height="100%" v-loading='tableLoading' max-height='500px' style='min-height:300px;'>
            <el-table-column type='index' label='序号' width="80"></el-table-column>
            <el-table-column prop="mobile_status" label="手机状态" />
            <el-table-column prop="repay_ability" label="还款意愿">
                <!-- <template slot-scope='{row}' v-if='getOrderStatus.length>0'>{{checkOrderStatus(row.orderStatus).codeKey}}</template> -->
            </el-table-column>
            <!-- <el-table-column prop="creator" label="创建人"/> -->
            <el-table-column prop="operate_method" label="催收方式"/>
            <el-table-column prop="user_name" label="崔收人"/>
            <el-table-column prop="operate_date" label="催收时间">
                <template slot-scope="{row}">
                    {{$date.format(row.operate_date, "YYYY-MM-DD HH:mm:ss")}}
                </template>
            </el-table-column>
            <el-table-column prop="operate_result" label="催收结果"/>
        </el-table>
        <div class='tablepage'>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-size='pageSize'
            @current-change='getUser'
            :page-sizes="[10,20,30,40]"
            @size-change='sizeChange'
            :current-page.sync="current"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-else>
        <add-overdue :params='params' @back='close'/>
    </div>
  </div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import addOverdue from '@/components/addOverdue.vue'
export default {
    data() {
        return {
            form: {},
            dataList: [],
            title: '新增用户',
            visible: false,
            orderStatus: [

            ],
            roleNames: [],
            current: 1,
            total: 0,
            pageSize: 10,
            tableLoading: false,
            look: true
        }
    },
    components:{addOverdue},
    computed: {
        ...mapGetters([
            'getOrderStatus',
            'checkOrderStatus'
        ])
    },
    props: {
        params: {
            default: null
        }
    },
    watch: {

    },
    methods: {
        async getUser() {
            this.tableLoading = true
            let params = {
                ...{
                    current: this.current,
                    pageSize: this.pageSize
                },
                ...{keyWord:this.params.record.orderNo,period:this.params.record.period}
            }
            const rsp = await this.$http.collectionHistory(params)
            this.tableLoading = false
            if (rsp.code != 200) return
            this.dataList = rsp.data.records
            this.total = rsp.data.total
        },
        //新增催收记录
        add(){
            this.look = false
        },
        close(val){
            this.look = true
            if(val) this.getUser()
        },
        sizeChange(val) {
            this.pageSize = val
            this.getUser()
        },
    },
    
    created() {
        this.getUser()
        console.log(this.params)
    }
}
</script>

<style scoped>
.page {
    flex-direction: column;
}
</style>
